import { INotificationService } from '../../../core/notificationservice';
import { IGenerateReportService } from '../services/generateReportService';

export class GenerateReportController {

    private _fromDate: Date; private _toDate: Date;
    private _isLoading: boolean; private _isDisable: boolean;

    get fromDate(): Date {
        return this._fromDate;
    }

    set fromDate(val: Date) {
        this._fromDate = val;
    }

    get toDate(): Date {
        return this._toDate;
    }

    set toDate(val: Date) {
        this._toDate = val;
    }

    get isLoading(): boolean {
        return this._isLoading;
    }

    set isLoading(val: boolean) {
        this._isLoading = val;
    }

    get isDisable(): boolean {
        return this._isDisable;
    }

    set isDisable(val: boolean) {
        this._isDisable = val;
    }

    
    formGenerateReport: ng.IFormController;
    static $inject = ['$mdDialog', 'NotificationService', 'generateReportService'];

    constructor(
        private _$mdDialog: ng.material.IDialogService,
        private _notificationService: INotificationService,
        private generateReportService: IGenerateReportService
    ) {
    }

    $onInit(): void {
    }

    cancel(): void {
        this._$mdDialog.cancel();
    }

    compareDate(date: string, clickedDate: string): void {
        if (this._toDate !== undefined && this._toDate !== null && this._fromDate !== undefined && this._fromDate !== null) {
            var timeDiff = this._toDate.getTime() - this._fromDate.getTime();
            if (timeDiff < 0) {
                this.formGenerateReport['fromDate'].$setValidity('validationMsg', false);
                this.formGenerateReport['toDate'].$setValidity('validationMsg', false);
            }
            else if (timeDiff === 0) {
                this.formGenerateReport['fromDate'].$setValidity('validationMsg', true);
                this.formGenerateReport['toDate'].$setValidity('validationMsg', true);
            }
            else {
                this.formGenerateReport['toDate'].$setValidity('validationMsg', true);
                this.formGenerateReport['fromDate'].$setValidity('validationMsg', true);
            }
        }
        else
        {
            this.formGenerateReport['toDate'].$setValidity('validationMsg', true);
            this.formGenerateReport['fromDate'].$setValidity('validationMsg', true);
        }
    }

    generateReport() {
        this.isDisable = true;
        this.isLoading = true;
        if (this.formGenerateReport.$valid) {
            this.generateReportService.generateReport(this._fromDate, this._toDate).then(r => {
                if (r.byteLength === 0) {
                    this._notificationService
                        .showToastWithMentionedDelay("ATTACHMENT DOESN'T EXIST, PLEASE REFRESH PAGE",
                        5000);
                    this._$mdDialog.hide();
                } else {
                    this._$mdDialog.hide();
                    var byteArray = new Uint8Array(r);
                    var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'NSSR Requests Report.xlsx';
                    link.click();
                    this._notificationService.showToast('REPORT DOWNLOADED SUCESSFULLY');
                    this.isLoading = false;
                }
            }, (r) => {
                this._notificationService.showToast("The system could not process your download. If this problem persists, please contact the support team");
                this._isLoading = false;
            });
        }
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/generateReport/controllers/generatereportcontroller.ts
 **/